import { DELETE_USER_FAILURE, DELETE_USER_REQUEST, GET_USERS_FAILURE, GET_USERS_REQUEST, GET_USERS_SUCCESS, GET_VISITORS_FAILURE, GET_VISITORS_REQUEST, GET_VISITORS_SUCCESS } from "./ActionType";


const initialState = {
    loading: false,
    users: [],
    visitor: null,
    error: "",
}

const adminUserReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_USERS_REQUEST:
            return { ...state, loading: true };

        case GET_USERS_SUCCESS:
            return { ...state, loading: false, users: action.payload, error: "" };

        case GET_USERS_FAILURE:
            return { ...state, loading: false, users: [], error: action.payload };

        case GET_VISITORS_REQUEST:
            return { ...state, loading: true };

        case GET_VISITORS_SUCCESS:
            return { ...state, loading: false, visitor: action.payload, error: "" };

        case GET_VISITORS_FAILURE:
            return { ...state, loading: false, visitor: null, error: action.payload };

        case DELETE_USER_REQUEST:
            return { ...state, loading: true, error: "" };

        case DELETE_USER_FAILURE:
            return { ...state, loading: false, error: action.payload };

        default:
            return state;
    }
}
export default adminUserReducer